/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_When_AfterInputs */

const en_us2_bodymap_when_after = /** @type {(inputs: Bodymap_When_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After training`)
};

const pt_br2_bodymap_when_after = /** @type {(inputs: Bodymap_When_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois do treino`)
};

const es_419_bodymap_when_after = /** @type {(inputs: Bodymap_When_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después de entrenar`)
};

const pt_pt2_bodymap_when_after = /** @type {(inputs: Bodymap_When_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois do treino`)
};

const fr_fr2_bodymap_when_after = /** @type {(inputs: Bodymap_When_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Après l'entraînement`)
};

const de_de2_bodymap_when_after = /** @type {(inputs: Bodymap_When_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach dem Training`)
};

const it_it2_bodymap_when_after = /** @type {(inputs: Bodymap_When_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopo l'allenamento`)
};

/**
* | output |
* | --- |
* | "After training" |
*
* @param {Bodymap_When_AfterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_when_after = /** @type {((inputs?: Bodymap_When_AfterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_When_AfterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_when_after(inputs)
	if (locale === "es-419") return es_419_bodymap_when_after(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_when_after(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_when_after(inputs)
	if (locale === "de-DE") return de_de2_bodymap_when_after(inputs)
	if (locale === "it-IT") return it_it2_bodymap_when_after(inputs)
	return en_us2_bodymap_when_after(inputs)
});
export { bodymap_when_after as "bodymap.when.after" }